import { async } from "q"
import { axiosGet, axiosPost } from "../../../../../react_axios/Axios"
import { headers, getWaterDetailsUrl, insertUpdateWaterUrl, GET_WATER_DETAILS, INSERT_UPDATE_WATER, } from "../../../../../utils/constants"

export const getWaterDetails_action = () => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            ExhRegistrationID: parseInt(sessionStorage.getItem('ExhRegistrationIDSS')),
        }

        const res = await axiosGet(getWaterDetailsUrl, params)
        dispatch({
            type: GET_WATER_DETAILS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const insertUpdateWater_action = (Quantity, is_inletQuantity, is_outletQuantity, Remark, Is_Agree, descriptionList, ManualFormID, ServiceID, VendorDetails) => async (dispatch) => {
    try {
        const mapData = {
            UserID: parseInt(JSON.parse(sessionStorage.getItem('loginDataSS')).UserID),
            ExhibitionID: parseInt(sessionStorage.getItem('sessionExhibitionID')),
            ExhRegistrationID: parseInt(sessionStorage.getItem('ExhRegistrationIDSS')),
            Quantity: parseInt(Quantity),
            is_inletQuantity: is_inletQuantity != '' ? is_inletQuantity : 0,
            is_outletQuantity: is_outletQuantity != '' ? is_outletQuantity : 0,
            Remark: Remark,
            Is_Agree: Is_Agree,
            descriptionList: descriptionList,
            ManualFormID: ManualFormID,
            ServiceID: ServiceID,
            VendorDetails: VendorDetails

        }
        console.log("mapData-->", mapData)
        const res = await axiosPost(insertUpdateWaterUrl, mapData, headers)

        dispatch({
            type: INSERT_UPDATE_WATER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}
